import React, { useState } from 'react';
import { PathContext } from './PathContext';

// Accept 'initialPaths' as a prop
export function PathProvider({ children, initialPaths }) {
  // Use the prop to initialize the state
  const [paths, setPaths] = useState(initialPaths || {});

  // Function to update paths dynamically (if needed)
  const updatePath = (key, newPath) => {
    setPaths(prevPaths => ({
      ...prevPaths,
      [key]: newPath,
    }));
  };

  // The value provided to consumers
  const contextValue = { 
    paths, 
    updatePath
  };

  return (
    <PathContext.Provider value={contextValue}>
      {children}
    </PathContext.Provider>
  );
}
